
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import banner from '../pics/banner.PNG';
import trackOrder from '../pics/track_order.PNG';
import washdryironfold from '../pics/washdryironfold.PNG';
import washDryFold from '../pics/washdryfold.PNG';
import priceList from '../pics/pricelisticon.png'
import profile from '../pics/profile_.PNG';
import logout from '../pics/logout.PNG';
import ironFoldonly from '../pics/Ironandfold.PNG';
import Logout from '../Logout/Logout';
import { FaWhatsapp } from 'react-icons/fa';
import About from '../About/About';
import { isLoggedIn, getAllSubscriptions, getUserDeviceToken, handleRealTimeUpdate } from '../Utils/Utils';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import maleIcon from '../pics/maleProfileIcon.png';
import femaleIcon from '../pics/femaleProfileIcon.png';
import { LayoutDashboard, Menu } from 'lucide-react';
//import { ArrowRightCircle, ArrowRightCircleFill } from 'react-bootstrap-icons';
import { BsPencil } from 'react-icons/bs';
import { Fa500Px, FaPlusSquare } from "react-icons/fa";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { MdOutlinePriceChange } from "react-icons/md";
import { GrStatusGood } from "react-icons/gr";
import { FaTools } from "react-icons/fa";
import { GrView } from "react-icons/gr";
import { initPushNotifications } from '../../services/notificationService';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import axios from 'axios';
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
//import { redirect } from 'next/dist/server/api-utils';
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.handleLogOutOpen = React.createRef()
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        const webpush = require('web-push');
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            area: "",
            token: "",
            role: "",
            address: "",
            city: "",
            userid: "",
            gender: "",
            userstatus: "",
            registrationdate: "",
            allsubscriptions: [],
            deviceToken: "",
            userDeviceToken: "",
            // userToken: "",
            initials: this.props.location.state && this.props.location.state.fullname ? this.props.location.state.fullname.split(" ").map(name => name.charAt(0)).join("") : ""
        }
    }

    vapidPublicKey = 'BDlu-cTVRPmTgaAi1UeNJUwUERfCTC9QKPed497WcUG7gh5WWXyxx5_Q3LlNW6VggFVk_s4Ae9h1r_ZbGcv1tzE';

    firebaseConfig = {
        apiKey: "AIzaSyA-s0TGFcE_sIPV6YSjNJk8clTPiMCz7UU",
        authDomain: "iwash-laundry-2d327.firebaseapp.com",
        projectId: "iwash-laundry-2d327",
        storageBucket: "iwash-laundry-2d327.firebasestorage.app",
        messagingSenderId: "361330789184",
        appId: "1:361330789184:web:106c241e45f338be0c08a5"
    };

    app = initializeApp(this.firebaseConfig);
    messaging = getMessaging(this.app);
    isEnrollingNotification = false;

    // 2. Clear mobile device cache and save fresh registration tokens to MySQL
    async forceFreshMobilePushSubscription(currentUserId) {
        if (this.isEnrollingNotification) return;

        try {
            this.isEnrollingNotification = true;

            // 1. HARD WIPE: Check for any existing service workers and force unregister them
            if ('serviceWorker' in navigator) {
                const activeRegistrations = await navigator.serviceWorker.getRegistrations();

                for (let reg of activeRegistrations) {
                    console.log("Found conflicting service worker thread. Force unregistering...");
                    await reg.unregister(); // This completely drops any locked browser server keys
                }
            }

            // 2. RE-REGISTER: Register a completely clean instance of your service worker file
            console.log("Registering clean service worker instance...");
            const freshRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

            // Ensure the service worker is active and listening
            await navigator.serviceWorker.ready;

            // 3. GENERATE TOKEN: Let Firebase execute a clean token handshake
            const deviceToken = await getToken(this.messaging, {
                vapidKey: "BDlu-cTVRPmTgaAi1UeNJUwUERfCTC9QKPed497WcUG7gh5WWXyxx5_Q3LlNW6VggFVk_s4Ae9h1r_ZbGcv1tzE",
                serviceWorkerRegistration: freshRegistration
            });

            this.setState({ userToken: deviceToken, userDeviceToken: deviceToken })

            if (deviceToken) {
                console.log("Firebase cleanly generated mobile token:", deviceToken);

                // 4. DATABASE WRITE: Post the raw token to your corrected PHP save file
                const response = await axios.post(`https://testmembership.bktsystems.com/api/UAT_saveSubscription.php`, {
                    endpoint: deviceToken,
                    body: deviceToken,
                    userid: currentUserId
                });
                // console.log('---', response.data);

                console.log("Database Sync Server Response Details:", response.data);
            }

        } catch (error) {
            console.error("Mobile subscription enrollment dropped safely:", error);
        } finally {
            this.isEnrollingNotification = false;
        }

    }

    isUserDeviceRegistered = async (userToken) => {
        // const registrationToken = "DEVICE_TOKEN_HERE";

        const message = {
            token: userToken
            // No notification payload needed for a dry run
        };

        // Token check logic goes here
    }

    componentDidMount = async () => {

        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, userstatus: this.props.location.state.userstatus,
                address: this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, gender: this.props.location.state.gender, registrationdate: this.props.location.state.registrationdate
            })

            if (this.props.location.state.role.includes('Admin')) {

                document.getElementById('viewEditOrders').style.display = "block";
            }
        }
    }

    goToWashDryFold = (e) => {
        e.preventDefault();
        this.props.navigate('/washdryfold', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate

            }
        });
    }

    goToWashDryIron = (e) => {
        e.preventDefault();
        this.props.navigate('/washdryiron', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate

            }
        });
    }

    goToIronFoldOnly = (e) => {
        e.preventDefault();
        this.props.navigate('/ironfoldonly', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate

            }
        });
    }

    goToOrders = (e) => {
        e.preventDefault();
        this.props.navigate('/orders', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate, page:'allOrders'
            }
        });
    }
    goToTools = (e) => {
        e.preventDefault();
        this.props.navigate('/tools', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate,
            }
        });
    }
    goToDashboard = (e) => {
        e.preventDefault();
        this.props.navigate('/dashboard', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate
            }
        });
    }

    goToPricelist = (e) => {
        e.preventDefault();
        this.props.navigate('/pricelist', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate
            }
        });
    }

    goToTrackOrder = (e) => {
        e.preventDefault();
        this.props.navigate('/trackorder', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate
            }
        });
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    openLogOut = (e) => {
        this.handleLogOutOpen.current.handleLogOutOpen();
    }

    goToUserProfile = (e) => {
        //        console.log("Going to user profile with state: ", this.state);
        // e.preventDefault();
        this.props.navigate('/userprofile', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber, userstatus: this.state.userstatus,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                registrationdate: this.state.registrationdate
            }
        });
    }

    confirmLogout = () => {
        // Perform logout actions here (e.g., clearing tokens, redirecting)
        localStorage.removeItem("token");
        this.setState({ open: false });
        this.props.navigate('/', {
            state: {
            }
        });
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }
        return (
            <>
                <div style={{
                    height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px",
                    fontFamily: "lora" //backgroundColor: "#e0ded5",
                }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid white', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{ paddingTop: "10px", paddingBottom: "10px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold", textShadow: "2px 2px 4px #000000" }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>Welcome {(this.state.fullname).split(" ")[0]} </label></span><br /> */}
                            <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span>
                            <span style={{ position: "absolute", right: "50px", paddingTop: "100px" }}>
                                <RiLogoutCircleRLine size={40} color='orange' onClick={() => this.openLogOut()} />
                            </span>
                        </div>
                    </div>
                    <div style={{ paddingTop: "8px", textAlign: "center", color: "#0c0b07ff", width: "100%" }}>
                        <div style={{ width: "50%", float: "left" }}>
                            <Button style={{
                                border: "none", cursor: "default", display: "flex", backgroundColor: "white", textShadow: "1px 1px 2px grey",
                                paddingTop: "2vh", height: "60px", width: "100%", borderRadius: "10px", //backgroundColor: "#e0ded5",
                            }} ><Menu color="white" size={35} color='darkblue' /><label style={{ color: "darkblue", fontSize: "20px", fontWeight: "bold" }}> Menu</label>
                            </Button>
                        </div>
                        <div style={{ paddingLeft: '30%', width: '50%', top: '-1px', right: '-1px', overflow: 'hidden', position: 'relative', textAlign: "center" }}>
                            <img src={this.props.location.state.gender === 'Male' ? maleIcon : femaleIcon} alt="Profile"
                                style={{ borderRadius: '50%', width: '65px', height: '65px', border: '1px solid lightblue' }}
                            />

                            <div style={{ position: 'absolute', top: '50%', left: '80%', transform: 'translate(-50%, -50%)' }}>
                                <span style={{ fontStyle: "italic", fontsize: "14px", color: "darkblue" }} onClick={() => this.goToUserProfile()}>{this.state.initials}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", paddingTop: "8px", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%",
                            backgroundColor: "beige", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                            paddingTop: "20px", textShadow: "1px 1px 2px grey",
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToIronFoldOnly}>
                            <label ><FaPlusSquare size={40} /> IRON - FOLD ONLY</label></span>
                    </div>
                    <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey", paddingTop: "20px", textShadow: "1px 1px 2px grey",
                            borderRadius: "25px", paddingLeft: "5px", width: "100%", height: "100px", display: "inline-grid",
                            backgroundColor: "#FAF9F6", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                        }}
                            text="Wash - Dry & Fold" onClick={this.goToWashDryFold}>
                            <label><FaPlusSquare size={40} /> WASH - DRY & FOLD </label></span>
                    </div>
                    <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                            display: "inline-grid", fontWeight: "bold", color: "darkblue", backgroundColor: "beige", fontSize: "18px",
                            paddingTop: "20px"
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToWashDryIron}>
                            <label ><FaPlusSquare size={40} /> WASH - DRY - IRON - FOLD</label></span>
                    </div>

                    <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                            backgroundColor: "#FAF9F6", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                            paddingTop: "20px"
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToTrackOrder}>
                            <label ><GrStatusGood size={40} /> TRACK ORDER</label></span>
                    </div>

                    <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                        <span style={{
                            borderBottom: "2px solid grey",
                            borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                            backgroundColor: "beige", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                            paddingTop: "20px"
                        }} text="Wash - Dry, Fold & Iron" onClick={this.goToPricelist}>
                            <label ><MdOutlinePriceChange size={40} /> OUR PRICELIST</label></span>
                    </div>
                    <div id="viewEditOrders" style={{
                        display: this.props.location.state.role === 'Admin' ? 'inline-block' : 'none', borderRadius: "10px",
                        justifyContent: "center"
                    }} >
                        <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                            <span style={{
                                borderBottom: "2px solid grey",
                                borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                                backgroundColor: "#FAF9F6", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                                paddingTop: "20px"
                            }} text="Tools" onClick={this.goToTools}>
                                <label ><FaTools  size={40} />ADMIN TOOLS</label></span>
                        </div>
                        <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                            <span style={{
                                borderBottom: "2px solid grey",
                                borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                                backgroundColor: "beige", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                                paddingTop: "20px"
                            }} text="Wash - Dry, Fold & Iron" onClick={this.goToDashboard}>
                                <label ><LayoutDashboard size={40} /> DASHBOARD</label></span>
                        </div>
                        <div style={{ display: "flex", height: "120px", alignItems: "center" }}>
                            <span style={{
                                borderBottom: "2px solid grey",
                                borderRadius: "25px", height: "100px", paddingLeft: "5px", width: "100%", textShadow: "1px 1px 2px grey",
                                backgroundColor: "#FAF9F6", display: "inline-grid", fontWeight: "bold", color: "darkblue", fontSize: "18px",
                                paddingTop: "20px"
                            }} text="Wash - Dry, Fold & Iron" onClick={this.goToOrders}>
                                <label ><GrView size={40} /> VIEW EDIT ORDERS</label></span>
                        </div>
                        
                    </div>


                    <div style={{
                        marginTop: "5%", borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                        backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "5px", paddingBottom: "20px"
                    }}>
                        <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                        <div>
                            <Button style={{
                                backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                fontWeight: "bold", textDecoration: "underline"
                            }}
                                onClick={this.openAbout}>About Us
                            </Button>
                            | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>
                        </div>
                    </div>
                    <div>
                        <Logout
                            ref={this.handleLogOutOpen}
                            confirmLogout={this.confirmLogout}
                        />
                        <About
                            ref={this.handleAboutOpen}
                            onAboutClose={this.onAboutClose}
                        />
                    </div>
                </div>

            </>)

    }
}
export default withNavigateHook(Home);